import { useState } from 'react';
import { FaqAccordionItem } from '../ds/FaqAccordionItem';

type BlogFaqItemProps = {
  question: string;
  answer: string;
};

export function BlogFaqItem({ question, answer }: BlogFaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FaqAccordionItem
      item={{ q: question, a: answer }}
      isOpen={isOpen}
      showDivider={false}
      onToggle={() => setIsOpen((open) => !open)}
    />
  );
}
